// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSettings_root__q43yz"};